import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { QuillModule } from 'ngx-quill'


import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatIconRegistry,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS,
} from '@angular/material';

import { AuthServiceConfig } from 'angular5-social-login';
import { FacebookLoginProvider, GoogleLoginProvider } from 'angular5-social-login';
import { DomSanitizer } from '@angular/platform-browser';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask/src/currency-mask.config';

import { AppComponent } from './app.component';

import { AppRoutes } from './app.routing';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { RoleGuardService } from './services/role-guard.service';

import { ClientInterceptor } from './@core/interceptors/client-interceptor';
import { DeviceContextInterceptor } from './@core/interceptors/device-context.interceptor';
import { DeviceService } from './@core/services/device.service';
import { SmartfitPropostaService } from './services/smartfit-proposta.service';
import { ForbiddenComponent } from './modules/shared/pages/forbidden.component';

import { MomentModule } from 'ngx-moment';
import { ClientesLayoutComponent } from './modules/layouts/clientes/clientes-layout.component';
import { SharedModule } from './shared/shared.module';
import { PipeModule } from './@core/pipes/pipe.module';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { TranslateSharedModule } from './shared/translate/translate.module';
import { SysService } from './services/sys.service';
import { EditorStateService } from './services/editor-state.service';


export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: false,
  allowZero: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.'
};

export function getAuthServiceConfigs() {
  const config = new AuthServiceConfig([
    {
      id: FacebookLoginProvider.PROVIDER_ID,
      provider: new FacebookLoginProvider('1471573099578288')
    },
    {
      id: GoogleLoginProvider.PROVIDER_ID,
      provider: new GoogleLoginProvider('690940757822-jrr093pf2qieg1rd27erh5kqokp2kcun.apps.googleusercontent.com')
    }
  ]);
  return config;
}

@NgModule({
  imports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    CurrencyMaskModule
  ],
  exports: [
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    CurrencyMaskModule
  ],
  declarations: [],
})
export class MaterialModule {
}

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    RouterModule.forRoot(AppRoutes),
    HttpModule,
    HttpClientModule,
    MatDatepickerModule,
    CurrencyMaskModule,
    MomentModule,
    PipeModule,
    SharedModule,
    // TranslateModule,
    TranslateSharedModule,
    QuillModule.forRoot()
  ],
  declarations: [
    AppComponent,
    ForbiddenComponent,
    ClientesLayoutComponent
  ],
  exports: [
    // TranslateModule,
    TranslateSharedModule
  ],
  bootstrap: [AppComponent],
  providers: [
    DeviceService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DeviceContextInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ClientInterceptor,
      multi: true
    },
    AuthGuardService,
    RoleGuardService,
    AuthService,
    SysService,
    SmartfitPropostaService,
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: CURRENCY_MASK_CONFIG,
      useValue: CustomCurrencyMaskConfig
    },
    {
      provide: AuthServiceConfig,
      useFactory: getAuthServiceConfigs
    },
    EditorStateService
  ]
})
export class AppModule {
  constructor(
    //matIconRegistry: MatIconRegistry,
    domSanitizer: DomSanitizer,
  ) {
    console.log("[Carregando AppModule] ", new Date());
    // translate.setDefaultLang(environment.language);
    //matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg'));
    // Or whatever path you placed mdi.svg at
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts